import React from 'react';
import PropTypes from 'prop-types'
import { Box, Text } from 'tailwind-react-ui';

import previewImageIcon from '../assets/resources/preview-icon.png';

const EmailStatusMessage = ({message, srcImg}) =>{
    return (
        <>
        <Box className="flex items-start justify-between rounded-t">
             <img className="flex m-auto w-16 md:w-20"
                    src={srcImg}
                    alt={'envio-mail-error'}/>
        </Box>
        <Box className="flex items-start justify-between rounded-t">
            <Text is="p" text={'dark-light-gray'} className="quicksand-bold text-2xl mx-5 mt-5 mb-10">
                {message}
            </Text>
        </Box>
        </>
    );
}

EmailStatusMessage.propTypes = {
    srcImg: PropTypes.string,
    message: PropTypes.string,
}

EmailStatusMessage.defaultProps = {
    srcImg: previewImageIcon,
    message: "My Message",
}

export default EmailStatusMessage;

